import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isEqual } from 'lodash';
export function findFirst(arr) {
  return arr.find(Boolean);
}
export function areNonFunctionFieldsSame(prev, next) {
  var prevEntries = Object.entries(prev).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      _ = _ref2[0],
      value = _ref2[1];
    return typeof value !== 'function';
  });
  var nextEntries = Object.entries(next).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      _ = _ref4[0],
      value = _ref4[1];
    return typeof value !== 'function';
  });
  return isEqual(prevEntries, nextEntries);
}
export var checkIsClientSide = function checkIsClientSide() {
  return typeof window !== 'undefined';
};
export var redirect = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, _window) {
    var isClientSide;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isClientSide = checkIsClientSide();
          if (isClientSide) _window = window;
          return _context.abrupt("return", new Promise(function (res) {
            var _window2;
            if (!((_window2 = _window) !== null && _window2 !== void 0 && _window2.open)) throw new Error('Cannot open url');
            /** NOTE: https://stackoverflow.com/a/70463940 */
            setTimeout(function () {
              var _window$open, _window3;
              (_window$open = (_window3 = _window).open) === null || _window$open === void 0 || _window$open.call(_window3, url, '_self');
              // ideally we want to not resolve promise, because we wait until browser changes page
              // however, we want to resolve it in test scenarios
              if (!isClientSide) res();
            });
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function redirect(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();
export var processTrailingCases = function processTrailingCases(sum) {
  return sum.replace(/\./g, ',').replace(/,00/g, '');
};
export var wait = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ms) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new Promise(function (resolve) {
            setTimeout(resolve, ms);
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function wait(_x3) {
    return _ref6.apply(this, arguments);
  };
}();